import Link from "next/link";
import { CheckIcon } from "@heroicons/react/24/outline";
import { memo } from "react";

import { Button } from "@/components/ui/button";

export const LastCTA = memo(() => {
  return (
    <section
      id="ultimo-cta"
      style={{
        background:
          "linear-gradient(180deg, rgba(236,233,231,1) 10%, rgba(251,250,250,1) 90%)",
      }}
      className="rounded-[40px] sm:rounded-[60px] w-full md:w-[1200px] mx-auto"
    >
      <div className="flex flex-col items-center justify-center py-20 px-5 sm:px-16 gap-10">
        <p className="text-5xl sm:text-6xl font-bold text-center w-full md:w-[800px]">
          Encontre oportunidades únicas em um só lugar
        </p>
        <p className="text-xl text-center text-muted-foreground w-full sm:w-[600px]">
          Pesquise imóveis de leilão com filtros avançados e simplifique sua
          procura.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 w-3/5 sm:w-auto">
          <Button size="lg" className="px-6" asChild>
            <a
              href="/#encontre-seu-imovel"
              className="flex items-center justify-center gap-2"
            >
              Buscar imóvel
            </a>
          </Button>
          <Button size="lg" variant="outline" className="px-6" asChild>
            <Link href="/sign-up/">Criar conta</Link>
          </Button>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center justify-center gap-1">
            <div className="bg-primary-foreground rounded-full p-0.5">
              <CheckIcon width={18} height={18} className="text-primary" />
            </div>
            <p className="text-muted-foreground">Filtros avançados</p>
          </div>
          <div className="flex items-center justify-center gap-1">
            <div className="bg-primary-foreground rounded-full p-0.5">
              <CheckIcon width={18} height={18} className="text-primary" />
            </div>
            <p className="text-muted-foreground">Imóveis novos todos os dias</p>
          </div>
          <div className="flex items-center justify-center gap-1">
            <div className="bg-primary-foreground rounded-full p-0.5">
              <CheckIcon width={18} height={18} className="text-primary" />
            </div>
            <p className="text-muted-foreground">Teste grátis por 5 dias</p>
          </div>
        </div>
      </div>
    </section>
  );
});

LastCTA.displayName = "LastCTA";
